import { snack } from "components/Snack/Snack";
import CrudPage from "components/CrudPage/CrudPage";
import withRouter from "hoc/withRouter";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import { useLoadAll } from "hooks/useLoadAll";
import inputTypeEnum from "enums/inputTypes";
import amalsSAService from "services/superadmin/amalsSAService";
import AppSmartForm from "components/AppSmartForm/AppSmartForm";

const AmalForm = ({
  router: {
    navigate,
    params: { id },
  },
  data: { amal },
}) => {

  const fieldsWithData = [
    {
      key: "name",
      label: "Название",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "reward",
      label: "Награда",
      required: true,
      inputType: inputTypeEnum.text,
    },
    {
      key: "isActive",
      label: "Активный",
      inputType: inputTypeEnum.checkbox
    },
    {
      key: "translations",
      label: "Переводы",
      inputType: inputTypeEnum.array,
      fields: [
        {
          key: "name",
          label: "Название",
          inputType: inputTypeEnum.text,          
        }
      ]
    }
  ]

  const onSubmit = async (formValues) => {
    console.log("formValues: ", formValues);    
    try {
      if (amal) {
        await amalsSAService.put(id, formValues)
        snack("Амал обновлен успешно!");
      } else {
        await amalsSAService.post(formValues)
        snack("Амал создан успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex)
    }
  };

  return (
    <CrudPage title={amal ? 'Редактирование амала' : 'Создание амала'}>
      <AppSmartForm onSubmit={onSubmit} data={amal} fields={fieldsWithData}></AppSmartForm>
    </CrudPage>
  );
};

export default withRouter(
  withRemoteDataAndSpinner(AmalForm, (router) => {
    let requests = {}

    if (router.params.id) {
      requests['amal'] = () => amalsSAService.get(router.params.id)
    }
    return useLoadAll(requests);
  })
);
